import { GuardResult, MaybeAsync, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthenticationService } from '@flexyoo/auth';
import { RoleEnum } from '../../shared/models/general/general-enum';
import { appRoutesPerRoleDefaults } from '../../app-routes-per-role-defaults.constant';
import { map } from 'rxjs';
import { EmployeeSettingsService } from '@flexyoo/employee/data-access';

@Injectable()
export class EmployeeGuard {
  constructor(
    protected readonly router: Router,
    private readonly auth: AuthenticationService,
    private readonly employeeSettingsService: EmployeeSettingsService
  ) {}

  canMatch(): MaybeAsync<GuardResult> {
    const user = this.auth.getCurrentUser();

    if (!user) {
      const extractedUrl = this.router.currentNavigation()?.extractedUrl;
      let urlToRedirect = '';
      if (extractedUrl) {
        urlToRedirect = this.router.serializeUrl(extractedUrl);
      }
      this.auth.logout(urlToRedirect);
      return false;
    }

    if (user.Role === RoleEnum.Employee) {
      return this.employeeSettingsService.updateAndLoadEmployeeSettings(user.Id).pipe(
        map(({ userSettings, employeeSettings, tenantSettings }) => {
          if (userSettings?.isActive && employeeSettings?.isEligible && tenantSettings?.isActive) {
            return true;
          }
          this.auth.logout();
          return false;
        })
      );
    }

    if ([RoleEnum.Admin, RoleEnum.HR, RoleEnum.Opco].includes(user.Role as RoleEnum)) {
      return this.router.navigate([appRoutesPerRoleDefaults[user.Role]]);
    }

    this.auth.logout();
    return false;
  }
}
